
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    NEW: "NEW",
    MOD_L: "MOD_L",
    MOD_M: "MOD_M",
    COTS: "COTS",
    CFE: "CFE",
    OBS: "OBS"
};
